module.exports = __webpack_public_path__ + "img/Roro.630c4621.svg";